module.exports = __webpack_public_path__ + "media/images/icons/people-1e32a2b8740d31b98c3a40db2e87fb86.svg";